import React from "react";
import { LOGO_URL, COMPANY } from "@/data/site";

// Image logo for light surfaces (navbar)
export const Logo = ({ className = "h-11" }) => (
  <img
    src={LOGO_URL}
    alt={`${COMPANY.name} Logo`}
    className={`${className} w-auto object-contain`}
    data-testid="brand-logo"
  />
);

// Text-based logo mark for dark surfaces (footer)
export const LogoText = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo-text">
    <span className="grid h-11 w-11 place-items-center rounded-full bg-[var(--kilic-blue)] font-display text-xl font-black text-white">
      K
    </span>
    <span className="leading-tight">
      <span className="block font-display text-lg font-extrabold tracking-tight text-white">
        KILIC
      </span>
      <span className="-mt-1 block text-[0.62rem] font-semibold uppercase tracking-[0.25em] text-[var(--kilic-green)]">
        Gebäudeservice
      </span>
    </span>
  </div>
);
